import { CommonLocalStorageKeyEnum } from 'Feature/Common/Common/Types/Enums/CommonLocalStorageKeyEnum';
import { Storage } from 'Shared/Utils/LocalStorage/Storage';

import { IInsuranceModule } from '../models/IInsuranceModule';

export default class InsuranceModules extends Storage<CommonLocalStorageKeyEnum, IInsuranceModule> {
  private static instance?: InsuranceModules;

  private constructor() {
    super();
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new InsuranceModules();
    }

    return this.instance;
  }

  public getInsuranceModules(): IInsuranceModule[] {
    const result = this.get(CommonLocalStorageKeyEnum.INSURANCE_MODULES);
    if (Array.isArray(result)) return result;
    else return [];
  }

  public getInsuranceModulesWithExpiry(): IInsuranceModule[] {
    const result = this.getWithExpire(CommonLocalStorageKeyEnum.INSURANCE_MODULES);
    if (Array.isArray(result)) return result;
    else return [];
  }

  public setInsuranceModules(modules: IInsuranceModule[]): void {
    this.set(CommonLocalStorageKeyEnum.INSURANCE_MODULES, modules);
  }

  public setInsuranceModulesWithExpiry(modules: IInsuranceModule[], expiry: Date): void {
    this.setWithExpire(CommonLocalStorageKeyEnum.INSURANCE_MODULES, modules, expiry);
  }

  public clear(): void {
    this.clearItems([CommonLocalStorageKeyEnum.INSURANCE_MODULES]);
  }

  public modulesHasValue(): boolean {
    return this.hasValue(CommonLocalStorageKeyEnum.INSURANCE_MODULES);
  }

  public modulesIsExpire(): boolean {
    const isExpire = this.isExpire(CommonLocalStorageKeyEnum.INSURANCE_MODULES);
    if (isExpire) this.clear();
    return isExpire;
  }
}
